import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-line",
  "use": "icon-icon-line-usage",
  "viewBox": "0 0 1 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1 14\" id=\"icon-icon-line\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-line .cls-1 {\r\n        fill: #459fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <rect id=\"icon-icon-line_矩形_56\" data-name=\"矩形 56\" class=\"cls-1\" width=\"1\" height=\"14\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-line.svg
// module id = Zed0
// module chunks = 3